"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartLimits = exports.ChartConstDefaults = void 0;
exports.ChartConstDefaults = {
    sortOrder: ' asc',
    windowAlign: 'end',
    windowSize: 100,
    parentAggregateLimit: 200,
};
exports.ChartLimits = {
    AUTODETECT_CHART_LIMIT: 10,
    AUTODETECT_CHART_TOTAL_LIMIT: 32,
    AUTODETECT_MEASURES_LIMIT: 10,
    APPLY_LIMIT_AFTER_ROWS: 100,
    MAX_DISTINCT_VALUES: 10,
    VALID_VALUE_RATIO_LIMIT: 0.5,
    PIE_RATIO_LIMIT: 0.05,
    PIE_COUNT_LIMIT: 10,
    MAX_PIE_COUNT_LIMIT: 50,
    CHART_FILL_LIMIT: 10000,
    CHART_GROUP_LIMIT: 32, // limit for number of groups in a chart
};
